import type { TeacherScheduleItemDto } from "@madamuh/domain";
import { useState } from "react";
import {
  completeTeacherCommunicationAttachmentUpload,
  createTeacherCommunicationAttachment,
  createTeacherCommunicationAttachmentUploadSession,
  createTeacherMemberCommunication
} from "../../shared/api/memberCommunication";
import {
  buildTeacherOccurrenceCommunicationCategories,
  MemberCommunicationComposer,
} from "../../shared/ui/MemberCommunicationComposer";
import { GENERIC_TENANT_LABELS, type TenantLabels } from "../../shared/lib/tenantLabels";
import { formatTeacherDate, formatTeacherTimeRange } from "./teacherUi";

export function TeacherOccurrenceCommunicationPanel({
  tenantSlug,
  item,
  timeZone,
  onSent,
  labels = GENERIC_TENANT_LABELS
}: {
  tenantSlug: string;
  item: TeacherScheduleItemDto;
  timeZone: string;
  onSent?: () => Promise<void> | void;
  labels?: TenantLabels;
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div style={{ display: "grid", gap: 8 }}>
      <button type="button" onClick={() => setIsOpen((current) => !current)}>
        {isOpen ? "連絡フォームを閉じる" : "メンバーへ連絡"}
      </button>

      {isOpen ? (
        <div
          style={{
            border: "1px solid #e5e5e5",
            borderRadius: 12,
            padding: 12,
            display: "grid",
            gap: 10,
            background: "#fafafa"
          }}
        >
          <div style={{ display: "grid", gap: 4 }}>
            <strong>{item.lessonTitle}</strong>
            <div style={{ fontSize: 14, opacity: 0.8 }}>
              {formatTeacherDate(item.occurrenceDate, timeZone)} / {formatTeacherTimeRange(item.startAt, item.endAt, timeZone)}
            </div>
            <div style={{ fontSize: 14 }}>
              {labels.studio}: {item.studioNameSnapshot ?? (item.displayFlags.isStudioTbd ? "未定" : "未設定")}
            </div>
          </div>

          <MemberCommunicationComposer
            api={{
              createCommunication: (request) => createTeacherMemberCommunication(tenantSlug, request),
              createAttachment: (communicationId, request) => createTeacherCommunicationAttachment(tenantSlug, communicationId, request),
              createUploadSession: (communicationId, attachmentId) => createTeacherCommunicationAttachmentUploadSession(tenantSlug, communicationId, attachmentId),
              completeUpload: (communicationId, attachmentId, request) => completeTeacherCommunicationAttachmentUpload(tenantSlug, communicationId, attachmentId, request)
            }}
            categories={buildTeacherOccurrenceCommunicationCategories(labels)}
            defaultCategory="general"
            submitLabel="メンバーへ連絡"
            buildRequest={(values, attachmentType) => ({
              title: values.title || null,
              body: values.body || null,
              category: values.category,
              targetType: "occurrence",
              targetId: item.occurrenceId,
              publishFrom: null,
              publishTo: null,
              attachmentType
            })}
            onSuccess={async () => {
              await onSent?.();
              setIsOpen(false);
            }}
          />
        </div>
      ) : null}
    </div>
  );
}
